import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import ProfileUI from './ProfileUI';
import { auth } from './firebase-config';

const Layout = () => {
  const [user, setUser] = useState(null);

  // Firebase authentication check
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser);  // Set user when logged in
      } else {
        setUser(null);  // Clear user when logged out
      }
    });
    return () => unsubscribe(); // Cleanup listener
  }, []);

  return (
    <div className="app-container flex">
      <Sidebar /> {/* Sidebar stays here */}
      
      <div className="main-content flex-grow">
        {/* Profile Icon Container */}
        <div className="profile-icon-container">
          {/* Conditionally render ProfileUI only if user is signed in */}
          {user && <ProfileUI user={user} />}
        </div>

        {/* Main Content */}
        <Outlet /> {/* This will load the App or other sub-pages */}
      </div>
    </div>
  );
};

export default Layout;

